// extracted by mini-css-extract-plugin
export default {"ShopItemGallery_preview":"ShopItemGallery_ShopItemGallery_preview__jj9U1"};